<template>
  <div id="app">
    <app-header/>
    <div class="layout">
      <router-view></router-view>
    </div>
    <app-footer/>
  </div>
</template>

<script>

import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";

export default {
  name: 'App',
  components: {AppHeader, AppFooter},
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'DAVID CANNON',
    // all titles will be injected into this template
    titleTemplate: '%s | DAVID CANNON',
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'David Cannon is a fashion and portrait photographer.',
    }]
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  line-height: 1.6;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
